import { Divider } from '@cad-arc';
import { EventPanelConfiguration, EventPanelFormType, EventPanelOptions } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { EventPanelFormVehiclesFields } from './vehicles/event-panel-form-vehicles-fields';
import { EventPanelFormPersonsFields } from './persons/event-panel-form-persons-fields';

export function EventPanelFormNewEventEntities({
    eventForm,
    eventPanelOptions,
    eventPanelConfig,
}: {
    eventForm: UseFormReturn<EventPanelFormType>;
    eventPanelOptions: EventPanelOptions;
    eventPanelConfig?: EventPanelConfiguration;
}) {
    return (
        <>
            <Divider />
            <EventPanelFormPersonsFields
                showTitle
                form={eventForm}
                baseKey="reportingParties"
                addButtonText="Add Reporting Party"
                eventPanelOptions={eventPanelOptions}
                eventPanelConfig={eventPanelConfig}
                allowMembersControl={true}
            />
            <Divider />
            <EventPanelFormPersonsFields
                showTitle
                form={eventForm}
                baseKey="involvedPersons"
                addButtonText="Add Involved Person"
                eventPanelOptions={eventPanelOptions}
                eventPanelConfig={eventPanelConfig}
                allowMembersControl={true}
            />
            <Divider />
            <EventPanelFormVehiclesFields
                form={eventForm}
                eventPanelOptions={eventPanelOptions}
                addButtonText="Add Vehicle"
                allowMembersControl={true}
                showTitle={true}
                baseKey="vehicles"
            />
        </>
    );
}
